import { SVGProps } from "react";

export default function GoogleMeetIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4 1.40039L0 5.40039L2 6.63842L4 5.40039L5.12941 3.40039L4 1.40039Z"
        fill="#FF2820"
      />
      <path
        d="M4 5.40039H0V10.6004L2 11.6987L4 10.6004V5.40039Z"
        fill="#0084FF"
      />
      <path
        d="M0 10.5996V13.2663C0 13.9996 0.6 14.5996 1.33334 14.5996H4L5.12941 12.4764L4 10.5996H0Z"
        fill="#0066DD"
      />
      <path
        d="M15.1714 2.82136L12.6975 4.78108V4.80117L11.8906 7.88148L12.6975 10.9988L15.1604 12.981C15.4908 13.2583 15.9975 13.0254 15.9975 12.5928V3.20955C15.9975 2.77699 15.5018 2.54408 15.1714 2.82136Z"
        fill="#00AD3C"
      />
      <path
        d="M12.7 4.7803V2.71842C12.7 1.99352 12.1127 1.40039 11.395 1.40039H8.785H4V5.40039H8.9V8.00039L11.5326 7.70711L12.7 4.7803Z"
        fill="#FFBA00"
      />
      <path
        d="M8.9 10.6H4V14.6H8.785H11.395C12.1127 14.6 12.7 14.0078 12.7 13.2839V11L11.394 8.31684L8.9 8V10.6Z"
        fill="#00AD3C"
      />
      <path
        d="M8.89844 8.00134L12.6984 11.0013V4.78125L8.89844 8.00134Z"
        fill="#00831E"
      />
    </svg>
  );
}
